import request from 'superagent';
import Model from '../model';
import AutomessageSelector from './selector'
import * as actions from './actions';
import { toast } from 'react-toastify';

class Automessage extends Model {
    constructor() {
        super()
        this.selector = AutomessageSelector
    }

    static _sortMessages(messages) {
        messages.sort(function(a, b){
            return (a.message.message.priority - b.message.message.priority);
        });
        return messages;

    }

    read() {
        const selector = (state) => {
            return {
                'network' : this.networkSelector.get(state, 'automessage read'),
                'automessages': AutomessageSelector.getFrom(state)
            }
        }

        const dispatcher = () => {
            return (dispatch) => {
            const url = this.url()
            const token = this.token()
            dispatch(actions.automessageReadRequest());
            return request
                .post(`${url}/v1/company/automessage/get`)
                .send({})
                .set('Authorization', 'Bearer ' + token)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        const messages = Automessage._sortMessages(res.body.messages);
                        dispatch(actions.automessageReadSuccess(messages));
                    }
                    else{
                        dispatch(actions.automessageReadFailure(err, res));
                    }
                });
            }
        }

        return {dispatcher: dispatcher, selector: selector}
    }

    create(message, time, visitor, url, weekDays) {
        return (dispatch) => {
            const url1 = this.url()
            const token = this.token()
            dispatch(actions.automessageCreateRequest())
            return request
                .post(`${url1}/v1/company/automessage/create`)
                .send({
                    message: message,
                    time: time,
                    visitor: visitor,
                    url: url,
                    days_of_the_week: weekDays,
                })
                .set('Authorization', 'Bearer ' + token)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        let messages = Automessage._sortMessages(res.body.messages);
                        dispatch(actions.automessageCreateSuccess(messages));
                        toast.success("Automeddelande har skapats")
                    } else{
                        dispatch(actions.automessageCreateFailure(err, res));
                    }
                });
        }
    }

    delete(id) {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            dispatch(actions.automessageDeleteRequest(true));
            return request
                .post(`${url}/v1/company/automessage/remove`)
                .send({
                    auto_id: parseInt(id, 10)
                })
                .set('Authorization', 'Bearer ' + token)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        let messages = Automessage._sortMessages(res.body.messages);
                        dispatch(actions.automessageDeleteSuccess(messages));
                        toast.success("Automeddelande togs bort")
                    } else {
                        dispatch(actions.automessageDeleteFailure(err, res));
                    }
                });
        }
    }

    update(id, message, time, visitor, url, weekDays, notis=true) {
        return (dispatch) => {
            const url1 = this.url()
            const token = this.token()
            dispatch(actions.automessageUpdateRequest(true));
            return request
                .post(`${url1}/v1/company/automessage/update`)
                .send({
                    auto_id: parseInt(id, 10),
                    message: message,
                    time: time,
                    visitor: visitor,
                    url: url,
                    days_of_the_week: weekDays
                })
                .set('Authorization', 'Bearer ' + token)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch(actions.automessageUpdateSuccess(res.body.messages));
                        if(notis) toast.success("Automeddelandet är sparat.")
                    }else {
                        dispatch(actions.automessageUpdateFailure(err, res));
                    }
                });
        }
    }

}


export default new Automessage();



// WEBPACK FOOTER //
// ./src/model/AutoMessage/model.js